/* Transporte das chamadas de API do Portal do Responsável.

   Um serviço só: o de analytics (mesmo serviço que Inteligência Educacional
   usa para Professor/Gestor/Admin), mas só as 4 rotas próprias do Responsável
   (routes/Analytics/responsavel.php no backend, piso hasRole:S):
   analytics/responsavel/filhos, .../aluno/:id/execucao, .../tempo-online e
   .../comparativo. Ver lib/api.js.

   Duplicado de propósito em relação a
   pages/InteligenciaEducacional/lib/transport.js: módulo independente, sem
   import cruzado com a Inteligência Educacional. */

import URL from "../../../config/api";
import axios from "../../../config/axios";
import { store } from "../../../store/store";

const PREFIXO_ANALYTICS = "analytics";

/* Postgres serializa `numeric` como string em JSON (ex.: "nota_media": "8.7").
   Mesma normalização que a Inteligência Educacional faz no transport dela —
   ver o comentário lá para o porquê. */
const NUM_STRING = /^-?\d+(\.\d+)?$/;

export function normalizeNumbers(value) {
  if (Array.isArray(value)) return value.map(normalizeNumbers);
  if (value !== null && typeof value === "object") {
    const out = {};
    Object.keys(value).forEach(k => {
      out[k] = normalizeNumbers(value[k]);
    });
    return out;
  }
  if (typeof value === "string" && NUM_STRING.test(value)) return Number(value);
  return value;
}

const querystring = params => {
  if (!params) return "";
  const pares = Object.keys(params)
    .filter(
      k => params[k] !== undefined && params[k] !== null && params[k] !== ""
    )
    .map(
      k => `${encodeURIComponent(k)}=${encodeURIComponent(String(params[k]))}`
    );
  return pares.length ? `?${pares.join("&")}` : "";
};

const tokenDoRedux = () => {
  try {
    return store.getState().user.token;
  } catch (err) {
    return null;
  }
};

/* AnalyticsController::responder devolve { success, data } em sucesso; em
   erro (EscopoNegadoException, aluno fora do mart etc.) devolve HTTP não-2xx
   com { success: false, error } no corpo — o axios REJEITA nesse caso, então
   a mensagem real do backend só existe dentro de err.response.data. Sem
   extrair isto, o usuário veria "Request failed with status code 403" em vez
   de "Esse aluno não é vinculado a esse responsável.". */
function erroComMensagem(err) {
  const corpo = err?.response?.data;
  const mensagem =
    (corpo && typeof corpo === "object" && corpo.error) ||
    err?.message ||
    "Não foi possível carregar os dados.";
  const erro = new Error(mensagem);
  erro.status = err?.response?.status ?? null;
  return erro;
}

export async function getAnalytics(path, params) {
  try {
    const resp = await axios.get(
      `${URL.api}${PREFIXO_ANALYTICS}${path}${querystring(params)}`,
      { headers: { authorization: `Bearer ${tokenDoRedux()}` } }
    );
    return normalizeNumbers(resp.data.data);
  } catch (err) {
    throw erroComMensagem(err);
  }
}
